// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__34uaO","question":"Question_question__3ayJc","description":"Question_description__3cre6"};